/*
=========================================================
  ____    ___    ____   _   __       __                
 |  _ |  / _ \  |  _ \ | | |   \    |   \  ___  __ __  
 |  __| | |_| | |  __/ | | | |) | o | |) |/ -_) \ V /  
 |_|\_\ |_| |_| |_|    |_| |___/    |___/ \___|  \_/    o o o   

=========================================================
*/

import {
  CLEAR_STATE,
  SET_TOKEN,
  SET_LANG,
  SET_USER,
  SET_PERM,
  SET_MENU,
  SET_NOTIFY,
  SET_BADGE,
} from "../actions/appAction";

const initialState = {
  token: "",
  lang: "th",
  user: {
    id: "",
    name: "",
    image: "",
  },
  perm: {},
  menu: [],
  notify: {
    count: 0,
    data: [],
  },
  badge: {
    get_offer: 0,
    is_arrived: 0,
    buyin_transaction: 0,
    vpark_transaction: 0,
    v_request: 0,
    wait_for_return: 0,
    showroom_appointment: 0,
  },
};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_STATE:
      return initialState;
    case SET_TOKEN:
      return { ...state, token: action.payload };
    case SET_LANG:
      return { ...state, lang: action.payload };
    case SET_USER:
      return { ...state, user: action.payload };
    case SET_PERM:
      return { ...state, perm: action.payload };
    case SET_MENU:
      return { ...state, menu: action.payload };
    case SET_NOTIFY:
      return { ...state, notify: action.payload };
    case SET_BADGE:
      return { ...state, badge: action.payload };
    default:
      return state;
  }
}
